﻿// NG 2
import { Injectable, OnInit } from '@angular/core';
import { Http, Response } from '@angular/http';
import { Observable } from 'rxjs/Rx';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';

// APP
import { AppConfig } from '../app.config';
import { ProgressService } from './progress.service';
import { BaseService } from './base.service';

@Injectable()
export class LookupService extends BaseService {  
    _baseUrl: string = AppConfig.config.defaultServicePath +  'MIHLookup/';   

    constructor(private http: Http
        , private progressService: ProgressService) {
            super();
    }

    getLookups(groupName) {
        this.progressService.add();
        return this.http.get(this._baseUrl + 'lookupvalues?name=' + groupName, this.addHeader())
            .map((resp: Response) =>resp.json())
            .catch(this.errorHandler)
            .finally(() => this.progressService.remove())
    }
}